import { getCurrentUrl } from './getCurrentUrl';
import { isSSR } from './isSSR';
export const getClientQueryParam = queryParam => isSSR() ? null : getCurrentUrl().searchParams.get(queryParam);
//# sourceMappingURL=getClientQueryParam.js.map